import Vue from "vue";
import axios from "axios";
let currentLang = JSON.parse(document.getElementById('langSite').innerHTML).lang
const lang = currentLang == 'fr' ? '/' : `/${currentLang}/`
const baseUrl = `${lang}wp-json/wp/v2` 

if (document.getElementById("vue-products-pro")) {
  const categoryID = document.getElementById('vue-products-pro').dataset.category
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const products = await $http.$get(`${baseUrl}/products_pro`);
      return { products };
    },
    el: "#vue-products-pro",
    data() {
      return {
        categoryID: '',
        filters: {
          page: 1,
          per_page: 8,
        },
        products: [],
        product_types: [],
        product_lines: [],
        totalPages: null,
      };
    },
    computed: {
      hasMore() {
        return this.totalPages > this.products.length;
      },
    },
    created() {
      this.getProducts();
    },
    mounted() {
      if (this.$refs.filterPro) {
        this.getInitialData();
      }
      window.addEventListener('hashchange', () => {
        this.filters.products_type = Number(window.location.hash.substr(1))
        this.getProducts();
      }, false);
      this.getTypes();
      this.getLines();
      if(window.location.hash){
        this.filters.products_type = Number(window.location.hash.substr(1))
        this.getProducts();
      }
    },
    methods: {
      deleteEmptyCategories(cat) {
        return cat.filter((el) => el.count != 0)
      },
      getInitialData() {
        this.categoryID = this.$refs.filterPro.dataset.category
      },
      getTypes() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/products_type`,
            params: {
              per_page: 8,
            },
          })
          .then((response) => {
            this.product_types = response.data;
          });
      },
      getLines() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/products_type?parent=${categoryID}`,
            params: {
              per_page: 8,
            },
          })
          .then((response) => {
            this.product_lines = this.deleteEmptyCategories(response.data)
          });
      },
      getProducts(more = false) {
        if (this.filters.products_type === "") {
          delete this.filters.products_type;
        }
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/products_pro?products_type=${categoryID}`,
            params: this.filters,
          })
          .then((response) => {
            if (more) {
              this.products = this.products.concat(response.data);
            } else {
              this.products = response.data;
            }
            this.totalPages = response.headers["x-wp-total"];
          })
          .catch((error) => {
            this.errors = Object.assign(this.errors, error.response.data);
          });
      },
      getMoreProducts() {
        this.filters.page++;
        this.getProducts(true);
      },
      getLine(sector_id) {
        let sector = this.product_lines.filter(
          (obj) => obj.id === sector_id
        )[0]["name"];
        return sector;
      },
      getType(type_id) {
        let type = this.product_types.filter((obj) => obj.id === type_id)[0][
          "name"
        ];
        return type;
      },
      updateLine(line) {
        if (line) {
          this.filters.page = 1
          this.filters.products_type = line;
        } else {
          delete this.filters.products_type;
        }
        this.getProducts();
      },
    },
  });
}
